import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
declare let zsuite: any;

@Injectable({
  providedIn: 'root'
})
export class ZSuiteService {

  constructor(private router: Router) { }

  registerCloudInZSuite(): void {
    zsuite.registerCallback((methodName: string, args: string[]) => {
      var m = methodName.charAt(0).toLowerCase() + methodName.slice(1);
      this[m](args);
    });
  }

  logout(): void {
    zsuite.logout();
  }

  goToUrl(url: string): void {
    zsuite.goToUrl(url);
  }

  private goToCloudUrl(args: string[]) {
    this.router.navigateByUrl(args[0]);
  }
}
